// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".h-drawer-menu-group{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start}.h-drawer-menu-group__item{width:50%;padding:10px 20px}.h-drawer-menu-group--remove-edge-divider .h-drawer-menu-group__item:first-child{border-top:0}.h-drawer-menu-group--remove-edge-divider .h-drawer-menu-group__item:last-child{border-bottom:0}", ""]);
// Exports
module.exports = exports;
